/**
 * Generates a callback to be called when info icon is pressed, sends tealium tracking and onInfoIconPress callback
 *
 * @param {object} params - Parameters
 * @param {string} params.analyticsTitle - title to pass to tealium
 * @param {string} params.screenName - the route name from react navigation
 * @param {function} params.onInfoPress - a callback to call on Press
 * @param {function} params.sendEvent - a callback to send the tealium request
 *
 * @returns {function} - Callback - A function to be called when tab is pressed
 */
export function generateOnInfoPress({
  analyticsTitle,
  screenName,
  onInfoPress,
  sendEvent,
  lastPaidRank,
}: any) {
  return (payload?: any) => {
    if (onInfoPress) {
      onInfoPress(payload);
    }
    sendEvent?.({
      buttonName: analyticsTitle,
      screenName,
      lastPaidRank,
    });
  };
}
